export default __webpack_public_path__ + "static/javascript-frameworks-amico-4421ef32bbfa046facb08aef2067dae2.svg";